import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Maria R.",
    role: "Amministratrice di condominio — Lecce",
    service: "Pulizie e Verde",
    text: "Gestiscono pulizie e aree verdi del nostro condominio da un anno. Puntuali, precisi e sempre disponibili. Non li cambierei per nulla al mondo.",
  },
  {
    name: "Giuseppe L.",
    role: "Privato — Lecce",
    service: "Trasloco",
    text: "Trasloco perfetto: squadra gentile, cura maniacale dei mobili e tempi rispettati al minuto. Prezzo esattamente quello del preventivo.",
  },
  {
    name: "Villaggio Le Palme",
    role: "Struttura turistica — Salento",
    service: "Pulizie Villaggi",
    text: "Per la stagione estiva ci affidiamo a HELPLY per interni ed esterni. Un unico referente per tutto: ci ha cambiato l'organizzazione.",
  },
  {
    name: "Anna P.",
    role: "Privata — Cavallino",
    service: "Cura del Verde",
    text: "Hanno trasformato il nostro giardino abbandonato in uno spazio meraviglioso. Progettazione curata nei dettagli e manutenzione sempre puntuale.",
  },
];

export default function Recensioni() {
  return (
    <section id="recensioni" data-testid="recensioni-section" className="relative py-24 lg:py-32">
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 50%, rgba(53,101,174,0.07), transparent 65%)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="font-mono text-xs uppercase tracking-[0.25em] text-neon"
        >
          {"// Dicono di Noi"}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="mt-4 max-w-2xl font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl"
        >
          La fiducia di chi <span className="text-pulse">ci ha già scelto.</span>
        </motion.h2>

        <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-2">
          {REVIEWS.map((r, i) => (
            <motion.blockquote
              key={r.name}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: (i % 2) * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group relative rounded-2xl border border-[#D9E4F5] bg-white p-8 shadow-[0_8px_32px_rgba(22,52,95,0.08)] transition-all duration-500 hover:-translate-y-1 hover:border-neon/50"
            >
              <Quote className="absolute right-6 top-6 h-8 w-8 text-neon/15 transition-colors duration-500 group-hover:text-neon/30" />
              <div className="flex gap-1">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-pulse text-pulse" />
                ))}
              </div>
              <p className="mt-5 text-sm leading-relaxed text-slate-600 sm:text-base">
                "{r.text}"
              </p>
              <footer className="mt-6 flex items-center justify-between gap-4 border-t border-[#D9E4F5] pt-5">
                <div>
                  <p className="font-display text-sm font-semibold text-[#16345F]">{r.name}</p>
                  <p className="mt-0.5 text-xs text-slate-500">{r.role}</p>
                </div>
                <span className="shrink-0 rounded-full border border-neon/30 bg-neon/10 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-neon">
                  {r.service}
                </span>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
